import { render, staticRenderFns } from "./OptimizeHorBarChart.vue?vue&type=template&id=ea0f89d6"
import script from "./OptimizeHorBarChart.vue?vue&type=script&lang=js"
export * from "./OptimizeHorBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports